export const getFY = (increment = 0, date: Date = new Date()): string => {
  const transformedDate = new Date(date);
  const year = parseInt(transformedDate.getFullYear().toString().substring(2));
  const month = transformedDate.getMonth() + 1;
  if (month < 9) return `FY${year + increment}`;
  return `FY${year + 1 + increment}`;
};

export const getFyNumber = (string: string) =>
  string && parseInt(string.replace(/[^0-9]/g, ''));

export const updateFy = (string: string, amount: number): string => {
  const fyNumber = getFyNumber(string);

  if (!fyNumber || !amount) {
    return '';
  }

  return `FY${fyNumber + amount}`;
};

export const getFyRange = (fy: string): string => {
  const fyNumber = getFyNumber(fy);
  return fyNumber ? `FY${fyNumber} - FY${fyNumber + 2}` : fy;
};

export const getDifferentFY = (fy = getFY()) => {
  const fyNumber = getFyNumber(fy);
  const minimum = fyNumber;
  const maximum = fyNumber + 5;
  const fyArray = [];
  for (let i = minimum; i <= maximum; i++) {
    fyArray.push(`FY${i}`);
  }
  return fyArray;
};
